<template>
    <div class="page-class"
        :class="[{'page-mass': theme == 'mass'}, {'page-prestige': theme == 'prestige'}]">
        <div v-if="isAccountLoaded">
            <AIAHeader
                :modalController="modalController"
                @clickBack="clickBack" />
            <HomeDashboard
                :modalController="modalController"
                @apiLoaded="apiLoaded" />
            <HomeWelcome
                v-if="welcomeConfig.isEnable && theme == 'prestige'"
                :lbl="lbl"
                :localeCode="localeCode"
                :welcomeConfig="welcomeConfig"
                :modalController="modalController"
                @apiLoaded="apiLoaded" />
            <HomeCategory
                :ambassadorCatId="ambassadorCatId"
                :modalController="modalController"
                @apiLoaded="apiLoaded" />
            <AIAFootMenu
                :pageName="pageName"
                :modalController="modalController" />
        </div>
        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//layout
import AIAHeader from "@/components/Layout/header/AIAHeader.vue";
import AIAFootMenu from "@/components/Layout/footer/AIAFootMenu.vue";
//component
import HomeCategory from "../component/share/HomeCategory.vue";
import HomeDashboard from "../component/share/HomeDashboard.vue";
import HomeWelcome from "@/module/Home/component/prestige/HomeWelcome.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
// helper
import { TrackingService } from "@/helper/TrackingHelper.js";
import Account from "@/helper/AccountHelper.js";

export default {
    name: "home",
    components: {
        //component
        HomeCategory,
        HomeDashboard,
        HomeWelcome,
        //layout
        AIAHeader,
        AIAFootMenu,
        //modal
        ModalMaster,
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            pageName: 'home',
            //loading
            isLoading: false,
            isDashboardLoaded: false,
            isMenuCategoryLoaded: false,
            //modal
            modalController: null,
            alertModal: null,
            loadingModal: null,
            confirmModal: null,
            userTierChannel: null,

            trackingService: new TrackingService(this),
            trackingScreenName: 'homepage',
        };
    },
    computed: {
        ambassadorCatId: function () {
            return this.$store.getters.getAmbassadorCatId;
        },
        closeUrl: function () {
            return this.$store.getters.getCloseWebUrl;
        },
        closeAiaPlusUrl: function () {
            return this.$store.getters.getCloseAiaPlusUrl;
        },
        welcomeConfig: function () {
            return this.$store.getters.getWelcomeLbl;
        }
    },
    created: function() {
        //Vue.ga.screenName(this, 'Home');
        //Vue.ga.event(this, "new cat", "view page", "home label");
        //initial
        this.initialModal();
        this.errorHandler.setAlertModal(this.modalController.alertModal);
        this.errorHandler.setNoInternetModal(this.modalController.noInternetModal);

        this.trackingService.screenName(this.trackingScreenName);
        this.userTierChannel = Account.getCacheProfileExtensionJson();
    },
    mounted: function () {
        this.showLoading();
    },
    methods: {
        //event
        clickBack: function () {
            if (this.userTierChannel && this.userTierChannel.Tier
                && this.userTierChannel.Tier.CHANNEL == 'aiaplus') {
                if (this.closeAiaPlusUrl)
                window.open(this.closeAiaPlusUrl);

            } else {
                if (this.closeUrl)
                window.location.replace(this.closeUrl);
            }
        },
        //initial
        accountInitiated: function () {
            this.initialHome();
        },
        initialHome: function () {

        },
        //modal
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.confirmModal = modalFactory.getConfirmModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
        },
        //loading
        apiLoaded: function (data) {
            switch(data.api) {
                case 'dashboard':
                    this.isDashboardLoaded = true;
                    break;
                case 'menucategory':
                    this.isMenuCategoryLoaded = true;
                    break;
                case 'welcome':
                    this.isWelcomeLoaded = true;
                    break;
            }

            if (this.isDashboardLoaded
                && this.isMenuCategoryLoaded) {
                if (this.isHaveWelcome) {
                    if (this.isWelcomeLoaded)
                        this.hideLoading();
                } else {
                    this.hideLoading();
                }
            }
        },
        showLoading: function (isFirstInit) {
            if (!isFirstInit) {
                if (this.isLoading) return true;
            }

            this.isLoading = true;
            this.loadingModal.show();

            return false;
        },
        hideLoading: function () {
            this.isLoading = false;
            this.loadingModal.hide();
        }
    },
};
</script>
